import { render, staticRenderFns } from "./UserPerformanceReport.vue?vue&type=template&id=673aa87c"
import script from "./UserPerformanceReport.vue?vue&type=script&lang=js"
export * from "./UserPerformanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports